import React, {Component} from 'react';
import "./Error.css";
import errorImg from "../../images/404.png";
import 'bootstrap/dist/css/bootstrap.css';
import {Button} from "react-bootstrap";

class Forbidden extends Component {
    constructor(props) {
        super(props);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        window.location.href = '/';
    }

    render() {
        return (<div className="container-fluid row containerStyl">
                <div className="errorBodyStyl">
                    <img src={errorImg} className='errorImg' alt={"error"}/>
                    <h2 className='oops'>403 UNAUTHORIZED REQUEST !!!</h2>
                    <h5 className='text-muted' style={{textAlign: 'center'}}>You are not allowed to access this
                        site.</h5>
                    <div className='buttondiv'>
                        <Button type="button" onClick={this.handleSubmit}
                                className="errorSubmit">
                            Go to Login
                        </Button>
                    </div>
                </div>
            </div>);
    }
}

export default Forbidden;
